import styled from 'styled-components';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { FaStore, FaUsers, FaUser, FaBox } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import CurrencyIcon from './CurrencyIcon';
import { useCurrencyName } from '../utils/currency';

const PageContainer = styled.div`
  background: ${props => props.theme.background};
  min-height: 100vh;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding-top: var(--tg-content-safe-area-inset-top, 0px);
  ${'' /* padding-bottom: var(--tg-safe-area-inset-bottom, 0px); */}
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: var(--tg-content-safe-area-inset-top, 48px); // Отступ сверху для всех страниц
  padding-bottom: ${({ isSupport }) => isSupport ? '0' : 'calc(var(--tg-safe-area-inset-bottom, 0px) + 62px)'};
  
  /* Скрываем скроллбар */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BottomNav = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  background: ${props => props.theme.card.background};
  border-top: 1px solid ${props => props.theme.border};
  z-index: 100;
  padding-left: var(--tg-safe-area-inset-left, 0px);
  padding-right: var(--tg-safe-area-inset-right, 0px);
  padding-bottom: var(--tg-safe-area-inset-bottom, 0px);
`;

const NavItem = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: ${props => props.active ? props.theme.primary : props.theme.text.secondary};
  transition: color 0.2s ease;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  
  &:hover {
    color: ${props => props.theme.primary};
  }
`;

const NavText = styled.span`
  font-size: 12px;
  margin-top: 4px;
`;

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currencyName = useCurrencyName(2);

  const handleTabClick = (path) => {
    if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
    }
    navigate(path);
    // Прокрутка вверх
    setTimeout(() => {
      const content = document.querySelector('.ContentWrapper');
      if (content) content.scrollTop = 0;
      window.scrollTo({ top: 0, behavior: 'auto' });
    }, 0);
  };

  const tabs = [
    { id: 'tokens', title: t('currency_title'), icon: <CurrencyIcon size={20} />, path: '/' },
    { id: 'store', title: t('nav.store'), icon: <FaStore size={20} />, path: '/cases' },
    { id: 'skins', title: t('skins.mySkins'), icon: <FaBox size={20} />, path: '/skins' },
    { id: 'friends', title: t('nav.friends'), icon: <FaUsers size={20} />, path: '/referrals' },
    { id: 'profile', title: t('nav.profile'), icon: <FaUser size={20} />, path: '/profile' }
  ];

  // Не показываем навигацию на определенных страницах
  const hideNavigation = (
    location.pathname.startsWith('/case/') ||
    location.pathname.startsWith('/case-result') ||
    location.pathname.startsWith('/skin/') ||
    location.pathname.startsWith('/packages') ||
    location.pathname.startsWith('/farm') ||
    location.pathname.startsWith('/trade-url') ||
    location.pathname === '/support' ||
    /^\/support\/ticket\//.test(location.pathname)
  );

  if (hideNavigation) {
    return null;
  }

  return (
    <BottomNav>
      {tabs.map((tab) => (
        <NavItem
          key={tab.id}
          onClick={() => handleTabClick(tab.path)}
          active={location.pathname === tab.path || location.pathname.startsWith(tab.path + '/')}
        >
          {tab.icon}
          <NavText>{tab.title}</NavText>
        </NavItem>
      ))}
    </BottomNav>
  );
};

const Layout = () => {
  const location = useLocation();
  const isSupportPage =
    location.pathname === '/support' ||
    /^\/support\/ticket\//.test(location.pathname);

  return (
    <PageContainer>
      <ContentWrapper isSupport={isSupportPage}>
        <Outlet />
      </ContentWrapper>
      <Navigation />
    </PageContainer>
  );
};

export default Layout; 